import type { FC } from 'react';
import { CircularProgress, Stack } from '@mui/material';

import ErrorOverlayWithRefetchButton from 'src/components/dashboard/DashboardPage/components/ErrorOverlayWithRefetchButton';

interface WidgetPlaceholderProps {
  loading?: boolean;
  errorMsg?: string;
  refetch?: () => void;
}

const WidgetPlaceholder: FC<WidgetPlaceholderProps> = ({
  loading,
  errorMsg,
  refetch,
}) => (
  <Stack
    direction="column"
    sx={{
      minHeight: 'inherit',
      justifyContent: 'center',
      position: 'relative',
    }}
  >
    {loading && !errorMsg && (
      <Stack
        direction="row"
        sx={{
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Stack>
    )}
    {!!errorMsg && (
      <ErrorOverlayWithRefetchButton errorMsg={errorMsg} refetch={refetch} />
    )}
  </Stack>
);

export default WidgetPlaceholder;
